import React from 'react'
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover'
import { Field, Form, Formik } from 'formik'
import { NumberInput } from './inputs/NumberInput'
import { Button } from './ui/button'
import { ProjectFormTypeEnum } from 'shared'
import { useGetProjectFormHeaderFooter } from '../model/api/project/useGetProjectFormHeaderFooter'
import { Spinner, useToast } from '@chakra-ui/react'
import { useSetProjectFormHeaderFooterMutation } from '../model/api/project/useSetProjectFormHeaderFooterMutation'

interface Props {
  projectId: string
  projectFormType: ProjectFormTypeEnum
}

export const HeaderFooterPopover: React.FC<Props> = (props) => {
  const toast = useToast()
  const { data, isLoading } = useGetProjectFormHeaderFooter(props.projectId, props.projectFormType)
  const { mutateAsync: setHeaderFooter, status } = useSetProjectFormHeaderFooterMutation()

  if (isLoading) {
    return (
      <div className="px-3 py-1 text-sm bg-gray-100 text-gray-900 rounded-md cursor-pointer">
        <Spinner size="xs" />
      </div>
    )
  }

  const initialRevisionNumber = data?.data?.revisionNumber || 1

  const onSubmit = async (values: { revisionNumber: number }) => {
    if (
      initialRevisionNumber > values.revisionNumber &&
      !window.confirm(
        `Současné číslo revize je ${initialRevisionNumber}. Skutečně jej chcete snížit na ${values.revisionNumber}?`,
      )
    ) {
    }

    try {
      await setHeaderFooter({
        project: props.projectId,
        projectFormType: props.projectFormType,
        revisionNumber: values.revisionNumber,
      })
      toast({
        title: 'Uloženo',
        status: 'success',
      })
    } catch (err) {
      console.error(err)
      toast({
        title: 'Chyba',
        status: 'error',
      })
    }
  }

  return (
    <Popover>
      <PopoverTrigger>
        <div className="px-3 py-1 text-sm bg-gray-100 text-gray-900 rounded-md cursor-pointer">
          Revize č. {initialRevisionNumber}
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-40">
        <div className="">
          <Formik initialValues={{ revisionNumber: initialRevisionNumber }} onSubmit={onSubmit}>
            {({ values }) => (
              <Form className="flex flex-col gap-3">
                <Field name="revisionNumber" component={NumberInput} stepper min={1} />
                <Button
                  disabled={values.revisionNumber === initialRevisionNumber}
                  isLoading={status === 'loading'}
                  type="submit"
                >
                  Uložit
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </PopoverContent>
    </Popover>
  )
}
